var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3023 24.2L57.7023 31.6L64.9023 22L61.8023 19.6L58.8023 23.6C55.9023 10 44.1023 0 30.2023 0C14.0023 0 0.902344 13.5 0.902344 30C0.902344 46.5 14.0023 60 30.2023 60C41.4023 60 51.8023 53.3 56.6023 42.9L53.1023 41.2C48.9023 50.2 39.9023 56 30.2023 56C16.2023 56 4.80234 44.3 4.80234 30C4.80234 15.7 16.2023 4 30.2023 4C42.3023 4 52.5023 12.7 55.0023 24.4L50.7023 21L48.3023 24.2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4023 18V35.9H38.1023V31.9H30.3023V18H26.4023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrExpired);
export default __webpack_public_path__ + "static/media/ubr-expired.6fd9a78a62e43b740a5ed39fc999cf21.svg";
export { ForwardRef as ReactComponent };